export default __webpack_public_path__ + "static/media/layer02.76c2e174.png";